import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrowGreen } from '../../../assets/images';
import AOS from 'aos';
import 'aos/dist/aos.css';

const History = () => {
    const { t, i18n } = useTranslation();
            const currentLanguage = i18n.language; // Aktif dili alıyoruz

     useEffect(() => {
        AOS.init({ duration: 2000, once: false }); 
      }, []);

  const cards = [
    {
      id: 1,
      title: 'Tarixçəmiz',
      description: 'Cortex Construction, 21.06.2018-ci ildə inşaat sektorunda yüksək keyfiyyət və etibar standartlarını təmin etmək məqsədilə qurulmuşdur. Şirkətimiz inşaat sahəsində innovativ həllər təqdim edərək, müasir texnologiyalardan istifadə edir. Hər layihəmizdə müştəri məmnuniyyəti və uzunmüddətli davamlılıq əsas prioritetimizdir.',
    },
    { 
      id: 2,
      title: 'Missiyamız',
      description: 'Bizim əsas missiyamız müştərilərimizə keyfiyyətli, təhlükəsiz və ekoloji cəhətdən davamlı tikinti həlləri təqdim etməkdir. Cortex Construction olaraq, müasir arxitektura və mühəndislik standartlarına əsaslanaraq, insanların həyatını daha rahat və təhlükəsiz etmək üçün çalışırıq.',
    },
    {
      id: 3,
      title: 'Təhlükəsizlik',
      description: 'Təhlükəsizlik Cortex Construction-un əsas prioritetlərindən biridir. Layihələrimizdə beynəlxalq standartlara uyğun təhlükəsizlik tədbirləri tətbiq edilir. Peşəkar heyətimiz mütəmadi olaraq təlimlərə cəlb olunur və inşaat meydanında müasir texnoloji avadanlıqlardan istifadə olunur. Bu yanaşma həm işçilərimizin, həm də ətraf mühitin təhlükəsizliyini tam təmin edir.',
    },
        {
      id: 4,
      title: 'Keyfiyyət',
      description: 'Keyfiyyət bizim hər addımımızın təməlində dayanır. Cortex Construction olaraq, istifadə etdiyimiz materiallardan tutmuş işin təhvilinə qədər hər mərhələdə yüksək standartlara əməl edirik. Müasir tikinti texnologiyalarını birləşdirərək, müştərilərimizin gözləntilərini üstələyən layihələr yaradırıq.',
    }
  ];

  return (
    <div data-aos="fade-up" className='mt-[56px] md:mt-[88px] '>
      <div className='max-w-containerSm md:max-w-container mx-auto'>
        <div className='grid grid-cols-1 md:grid-cols-4 gap-5'>
          {cards.map((card, i) => (
  <div
    key={i}
    className={`rounded-[16px] p-5 ${
      i === 0 ? "bg-[#2A3D63] text-white" : "text-[#1C1C1C]"
    }`}
  >
    <p className="text-[18px] md:text-[24px] text-medium">
      {t(card.title)}
    </p>
    <p className="mt-3">{t(card.description)}</p>
  </div>
))}
        </div>
      </div>
    </div>
  )
}

export default History
